module.exports = __webpack_public_path__ + "img/popup-chacter-2.c569427d.png";